import bus from "/src/utils/event_bus";
import { useSessionStore } from "@/stores/session";
import { useAppStore } from "@/stores/app";
import { useRefurbishmentStore } from "@/stores/refurb";
import { useShipmentsStore } from "@/stores/shipments";
import { usePartnumbersStore } from "@/stores/partnumbers";
import { useExternalShipmentsStore } from "@/stores/external_shipments";
import { useContainersStore } from "@/stores/containers";
import { logoutFromBackend } from "@/utils/api";
import router from '/src/router'


// WATCHERS THAT LAUNCH ACTIONS FROM SESSION STATE CHANGES


export const init_session_watchers = function () {
    const session_store = useSessionStore()

    session_store.$subscribe((mutation, state) => {
        console.log("🍍👁️ Empty watchers for session store.")
    })

    // EMERGENCY FIX: Add protection against multiple simultaneous logout events
    let isProcessingLogout = false;
    
    bus.on("events/session/logout", async () => {
        // EMERGENCY FIX: Prevent multiple simultaneous logout processes
        if (isProcessingLogout) {
            console.log("[Auth] Logout already in progress, ignoring duplicate event");
            return;
        }
        
        isProcessingLogout = true;
        console.log("[Auth] Logout event received, starting comprehensive cleanup")
        
        try {
            // Use the improved logout method from session store
            await session_store.logout()
            
            // Clean all other stores
            const app_store = useAppStore()
            const refurb_store = useRefurbishmentStore()
            const shipments_store = useShipmentsStore()
            const partnumbers_store = usePartnumbersStore()
            const external_shipments_store = useExternalShipmentsStore()
            const containers_store = useContainersStore()
            
            // Reset all stores
            refurb_store.resetStore()
            shipments_store.resetStore()
            partnumbers_store.resetStore()
            external_shipments_store.resetStore()
            containers_store.resetStore()
            
            console.log("[Auth] All stores cleaned successfully")
            
        } catch (error) {
            console.error("[Auth] Error during logout process:", error)
            
            // Fallback: force clean session even if logout fails
            session_store.cleanSession()
            session_store.resetStore()
            
            const app_store = useAppStore()
            app_store.resetStore()
        } finally {
            // Always redirect to login, regardless of logout success/failure
            console.log("[Auth] Redirecting to login page")
            router.push("/login").catch(() => {
                console.log("[Auth] Already on login page or navigation blocked")
            })
            
            // EMERGENCY FIX: Reset flag after a delay to allow for proper cleanup
            setTimeout(() => {
                isProcessingLogout = false;
                console.log("[Auth] Logout process flag reset");
            }, 3000);
        }
    })

}
